import types from './mutation-types';

export default {
  [types.SET_TABLE_DATA](state, tableData) {
    state.tableData = tableData;
  },
  [types.SET_LATEST_MATCH_DATA](state, matchData) {
    state.latestMatch = matchData;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js